// extracted by mini-css-extract-plugin
export default {"title":"SettingsSecurityDeleteAccount_title__KL0Lr","button":"SettingsSecurityDeleteAccount_button__a2O9u"};